import { createUseStyles } from 'react-jss';

export default createUseStyles({
  testRectOne: {
    width: '100px',
    height: '100px',
    backgroundColor: 'red',
  },

  testRectTwo: {
    width: '100px',
    height: '100px',
    backgroundColor: 'green',
  },

  container: {
    margin: '48px',
    '@media(max-width: 900px)': {
      margin: '20px',
    },
  },

  header: {
    fontFamily: 'Manrope',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',
    color: '#102131',
  },
  body: {
    marginTop: '36px',
    marginBottom: '50px',
    display: 'flex',
    justifyContent: 'center',
    '@media(max-width: 900px)': {
      marginTop: '10px',
      marginBottom: '25px',
    },
  },

  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    '& button': {
      width: '300px',
    },
  },
});
